import React from "react";
import classNames from "classnames";
import styles from "./actionName.css";

interface Props {
  name: string;
  isActive: boolean;
  onDelete?(): void;
}

export const MessageWidgetName = ({ name, isActive, onDelete }: Props) => {
  return (
    <div className={classNames(styles.container, { [styles.inactive]: !isActive })}>
      <i className={classNames("icon-doc", styles.icon)} />
      {name}
      {onDelete && (
        <i className={classNames("icon-close-cross", styles["delete-icon"])} onClick={onDelete} />
      )}
    </div>
  );
};
